var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-payment" },
    [
      _c("h3", { staticClass: "checkout-payment__title" }, [
        _vm._v("\n    Способ оплаты и скидки\n  ")
      ]),
      _c("p", { staticClass: "checkout-payment__text" }, [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")
      ]),
      _c(
        "ui-notification",
        {
          class: [
            "payment-notification",
            { disabled: _vm.paymentIsNotAvailable }
          ],
          attrs: { title: _vm.notificationTitle }
        },
        [
          _c(
            "div",
            {
              class: [
                "notification-description",
                { hidden: _vm.adaptive.isMobile && _vm.paymentIsNotAvailable }
              ]
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.notificationDescription) + "\n    "
              )
            ]
          ),
          _c("payment-icons", {
            staticClass: "notification-icons",
            attrs: { icon: _vm.paymentIcon }
          }),
          _c("ui-button", {
            class: [
              "notification-button",
              { hidden: _vm.onlyOneMethodAvailable }
            ],
            attrs: {
              slot: "action",
              blue: _vm.adaptive.isMobile,
              flat: !_vm.adaptive.isMobile,
              text: "Изменить"
            },
            on: { click: _vm.openModal },
            slot: "action"
          })
        ],
        1
      ),
      _c("checkout-promo"),
      _c("checkout-bonuses"),
      _c("payment-methods-modal", {
        attrs: {
          "payment-methods": _vm.paymentMethods,
          loading: !_vm.adaptive.isMobile && _vm.isLoading
        },
        on: { select: _vm.onSelectMethod },
        model: {
          value: _vm.paymentMethodsOpened,
          callback: function($$v) {
            _vm.paymentMethodsOpened = $$v
          },
          expression: "paymentMethodsOpened"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }